// extracted by mini-css-extract-plugin
export default {"wrapper":"Confirm_wrapper__4Ma1C","button":"Confirm_button__nUb3J"};